import createDebug from 'debug';
import { createURL } from '../../config';

const debug = createDebug('evp:api-client');

export interface Response<T = any> {
  status: number;
  message?: string;
  body?: T;
}

type HTTPMethod = 'GET' | 'POST' | 'PATCH' | 'PUT';

export default async function makeAPIRequest<Body = any>(
  path: string,
  body?: any,
  method: HTTPMethod = 'POST',
): Promise<Response<Body>> {
  const req: RequestInit = {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'same-origin',
  };

  if (method === 'POST' || method === 'PATCH' || method === 'PUT') {
    req.body = JSON.stringify(body);
  }

  debug('Making API requests to %s...', createURL(path));

  const res = await fetch(createURL(path), req);
  if (!res.ok) {
    debug('Request was unsuccessful %o', res);
    return {
      status: res.status,
      message: res.statusText,
    };
  }

  debug('Request was successful!');

  if (res.status !== 200) {
    debug('Response has non-200 status code (%d) not parsing body', res.status);
    return {
      status: res.status,
      message: res.statusText,
    };
  }

  debug('Parsing response body...', res.bodyUsed);
  return {
    status: res.status,
    body: await res.json(),
  };
}
